import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import story1 from '../images/story_1.png';
import story2 from '../images/story_2.jpg';
import story3 from '../images/story_3.jpg';
import story4 from '../images/story_4.png';
import story5 from '../images/story_5.jpg';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '../css/videos_seccion.css';
import { useProovedorData, returnFullURL } from '../components';
import { useNavigate } from 'react-router-dom';
import CallApi from '../data/CallApi';
import { ImagenesGlobal } from './global/ImagenesGlobal';

const CustomArrow = ({ className, style, onClick, Icon, hidden }) => {

  if (hidden) return null; // Si quieres ocultar completamente la flecha

  return (
    <div
      className={className}
      style={{
        ...style,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: '#fff',
        color: '#4d4d4d',
        fontSize: '20px',
        width: '40px',
        height: '40px',
        borderRadius: '50%',
        cursor: 'pointer',
        zIndex: 1,
        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
      }}
      onClick={onClick}
    >
      <Icon />
    </div>
  );
};

export const SeccionVideos = () => {
  const { listCompanies, setListCompanies, loadImageS } = useProovedorData();
  const navigate = useNavigate();

  const [currentSlide, setCurrentSlide] = useState(0);

  // Cantidad "por defecto" de slides que se muestran en escritorio
  const slidesToShowDesktop = 4;

  // Flechas ocultas según índice (si no te interesa ocultar flechas, puedes borrar esto)
  const hidePrev = currentSlide === 0;
  const hideNext = (currentSlide + slidesToShowDesktop >= listCompanies.length);

  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,          // Hacer que el slider se deslice automáticamente
    autoplaySpeed: 2000,
    speed: 600,
    slidesToShow: slidesToShowDesktop,
    slidesToScroll: 1,
    afterChange: (index) => setCurrentSlide(index),

    // Flechas personalizadas (solo en desktop / grandes pantallas)
    prevArrow: <CustomArrow Icon={FaChevronLeft} hidden={hidePrev} />,
    nextArrow: <CustomArrow Icon={FaChevronRight} hidden={hideNext} />,

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 480, // móviles
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 2,
          infinite: true,
          arrows: false,
        },
      },
    ],
  };

  function redirectCompany(nit) {
    if (String(nit).length <= 4) return;

    navigate(`/company/products?search=${nit}`);
  }

  async function loadCompanys() {
    const response = await CallApi({
      url: "api/company/list"
    });
    if (Array.isArray(response)) setListCompanies(response);
  }

  useEffect(() => {
    if (Array.from(listCompanies ?? []).length == 0) loadCompanys();
  }, []);

  return (
    <div className="carousel-container">
      {
        (listCompanies ?? []).length > 0 && (
          <Slider {...settings}>
            {listCompanies.map((objCompany, idx) => (
              <div className="story-card" key={idx}>
                <div style={{ backgroundColor: objCompany?.theme ?? '#989d96' }} onClick={() => redirectCompany(objCompany?.codeVisit)}>
                  <div style={{ width: '80%', aspectRatio: '1/1', overflow: 'hidden', borderRadius: '50%', border: '2px solid #fff' }}>
                    <ImagenesGlobal url={objCompany?.profile} type='picture' loadImageS={loadImageS} style={{ width: '100%', height: '100%', objectFit: 'fill' }} />
                  </div>

                  <ImagenesGlobal url={objCompany?.logo} type='cover' loadImageS={loadImageS} style={{ width: '80%', borderRadius: '12px', backgroundColor: '#fff' }} />
                </div>

              </div>
            ))}
          </Slider>
        )
      }
    </div>
  );
};
